import { useEffect, useState } from "react";
import { Box, Skeleton, useMediaQuery } from "@mui/material";
import aboutheroimage from "../assets/aboutheroimage.png";
import CustomText, { textStyles } from "../components/CustomText";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../components/BASE_URL";

const ProductTourHeader = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const [loading, setLoading] = useState(true);
  const [headerTitle, setHeaderTitle] = useState("");
  const [headerDesc, setHeaderDesc] = useState("");

  useEffect(() => {
    setLoading(true);
    fetch(
      `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Product_Tour`
    )
      .then((res) => res.json())
      .then((json) => {
        const section = json?.data?.find(
          (sec) => sec?.name?.trim().toLowerCase() === "product_tour"
        );

        if (section?.items?.length) {
          const selectedItem =
            i18n.language === "es"
              ? section.items.find((item) => item.idx === 1)
              : section.items.find((item) => item.idx === 0);

          setHeaderTitle(selectedItem?.title || t("Product Tour"));
          setHeaderDesc(selectedItem?.description || "");
        } else {
          setHeaderTitle(t("Product Tour"));
          setHeaderDesc("");
        }
      })
      .catch(() => {
        setHeaderTitle(t("Product Tour"));
        setHeaderDesc("");
      })
      .finally(() => setLoading(false));
  }, [i18n.language, t]);

  return (
    <Box
      sx={{
        mt: 8,
        position: "relative",
        backgroundImage: `url(${aboutheroimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: "rgba(4, 25, 35, 0.65)",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "#fff",
          height: "100%",
          px: 2,
          py: isMobile ? 8 : 11,
        }}
      >
        {loading ? (
          <Skeleton
            variant="text"
            height={isMobile ? 50 : 70}
            width={isMobile ? "80%" : "50%"}
          />
        ) : (
          <CustomText
            style={{
              ...textStyles.h1,
              color: "#E7EBF0",
              marginBottom: isMobile ? "0rem" : "1rem",
              marginTop: isMobile ? "0rem" : "0rem",
              fontSize: isMobile ? "40px" : "50px",
            }}
          >
            {headerTitle}
          </CustomText>
        )}

        {!loading && headerDesc && (
          <CustomText
            style={{
              ...textStyles.body2,
              color: "#EFEFEF",
              maxWidth: "1175px",
              margin: "0 auto",
              marginTop: isMobile ? "20px" : "6px",
              fontSize: "24px",
            }}
          >
            {headerDesc}
          </CustomText>
        )}
      </Box>
    </Box>
  );
};

export default ProductTourHeader;
